import { FiUser } from "react-icons/fi";
import { FiHome } from "react-icons/fi";
import { GoPackage } from "react-icons/go";
import { TbReportSearch } from "react-icons/tb";

const Navigation = [
  {
    name: "Home",
    to: "/userDash/home",
    icon: <FiHome />,
    current: false,
  },
  {
    name: "Reports",
    to: "/userDash/reports",
    icon: <GoPackage />,
    current: false,
  },
  {
    name: "Update Bank Details",
    to: "/userDash/manageBank",
    icon: <TbReportSearch />,
    current: false,
  },
  {
    name: "Settle to Bank",
    to: "/userDash/settletobank",
    icon: <TbReportSearch />,
    current: false,
  },
  {
    name: "Settlement Report",
    to: "/userDash/settlementreports",
    icon: <TbReportSearch />,
    current: false,
  },
  {
    name: "Complain",
    to: "/userDash/complain",
    icon: <TbReportSearch />,
    current: false,
  },
];

export default Navigation;
